import { useContext, useEffect } from 'react';
import { StyleSheetManager } from 'styled-components';
import { Outlet } from 'react-router';

import { MixpanelContext } from '../wrappers/mixpanel';
import './i18n';
import { ToastContainer } from '../features/toasts/components/toasts-container';
import { ModalOutlet } from '../core/modal/modal-outlet';
import { setSentryUser } from '../lib/sentry';
import { authStore } from '../core/stores/auth-store';
import { useUserGuiding } from './hooks/use-userguiding';

export const AppLayout = () => {
  const user = authStore.currentUser;

  const { init: initMixpanel, identify } = useContext(MixpanelContext);
  useUserGuiding();

  useEffect(() => {
    if (!user) {
      return;
    }

    if (process.env.NODE_ENV !== 'development') {
      initMixpanel();
      identify(user);
      setSentryUser(user);
    }
  }, [initMixpanel, identify, user]);

  return (
    <StyleSheetManager enableVendorPrefixes>
      <Outlet />
      <ToastContainer />
      <ModalOutlet />
    </StyleSheetManager>
  );
};
